export const LOCALES = {
    en: {
        name: 'English',
        flagCode: 'us',
    },
    es: {
        name: 'Español',
        flagCode: 'es',
    },
    zh: {
        name: '中文',
        flagCode: 'cn',
    },
    ru: {
        name: 'Русский',
        flagCode: 'ru',
    },
    ko: {
        name: '한국어',
        flagCode: 'kr',
    },
    ja: {
        name: '日本語',
        flagCode: 'jp',
    },
    it: {
        name: 'Italiano',
        flagCode: 'it',
    },
    de: {
        name: 'Deutsch',
        flagCode: 'de',
    },
    fr: {
        name: 'Français',
        flagCode: 'fr',
    },
};
//# sourceMappingURL=languages.js.map